import Time from "../axes/Time";
import Units from "../../../utils/Units";

let fontColor = "#888";
let hoverFontColor = "#000";
let iconTexts = {
    "wi wi-rain": String.fromCharCode(0xf019),
    "wi wi-showers": String.fromCharCode(0xf01a),
    "wi wi-snow": String.fromCharCode(0xf01b),
    "wi wi-cloud": String.fromCharCode(0xf041),
    "wi wi-day-rain": String.fromCharCode(0xf008),
    "wi wi-day-showers": String.fromCharCode(0xf009),
    "wi wi-day-snow": String.fromCharCode(0xf00a),
    "wi wi-day-cloudy": String.fromCharCode(0xf002),
    "wi wi-day-sunny-overcast": String.fromCharCode(0xf00c),
    "wi wi-day-sunny": String.fromCharCode(0xf00d),
};

let Weather = {
    type: "fontIconPoint",
    label: "Weather",

    fontColor: fontColor,
    hoverFontColor: hoverFontColor,
    font: "weathericons",
    pointRadius: 6,
    hitRadius: 0,
    pointHoverRadius: 8,
    maxGapSize: 40,
    drawCompositeOperation: 'multiply',

    fill: false,
    showLine: false,

    dataTransformCallback: (label, value) => {
        if (!value) {
            return {x: label, text: ''};
        }
        if (!value.hasOwnProperty('icon') ||
            "" === value.hasOwnProperty('icon') ||
            null === value.hasOwnProperty('icon')) {
            return null;
        }

        return Object.assign(value, {x: label, text: (value && value.hasOwnProperty('icon') && value.icon) ? iconTexts[value.icon] : ''});
    },
    tooltipLabelPrefixCallback: (label) => {
        return "";
    },
    tooltipLabelValueCallback: (yLabel, value) => {
        if (!value.y.wcc &&
            !value.y.wt) {
            return "";
        }

        return "Deckungsgrad: " + ((value.y.wcc !== null) ? Units.percent(value.y.wcc) : "-")
            + "\nTemperatur: " + ((value.y.wt !== null) ? Units.celcius(value.y.wt) : "-")
            + "\nNiederschlagsmenge: " + ((value.y.wpr !== null) ? Units.lperm2(value.y.wpr) : "-");
    },

    xAxis:Time
};

export default Weather;



// WEBPACK FOOTER //
// ./src/components/chart/channels/Weather.js